import { bootstrapApplication } from "@angular/platform-browser";

import { mergeApplicationConfig } from "@angular/core";

import { provideAuth0 } from "@auth0/auth0-angular";

import { appConfig } from "./app/app.config";
import { App } from "./app/app";

import { environment } from "./environments/environment";

const auth0Config = mergeApplicationConfig(appConfig, {
  providers: [
    provideAuth0({
      domain: environment.AUTH0.DOMAIN,
      clientId: environment.AUTH0.CLIENT_ID,
      authorizationParams: {
        redirect_uri: window.location.origin,
      },
      useRefreshTokens: true,
      cacheLocation: "localstorage",
    }),
  ],
});

bootstrapApplication(App, auth0Config).catch(err => console.error(err));
